module.exports = __webpack_public_path__ + "img/noimage.d223d15e.jpg";